import { createFileRoute } from '@tanstack/react-router'
import { type } from 'arktype'

import { PortalUnpaidInvoicesRecoveryPage } from '../../../../components/pages/unpaid-invoices-recovery/portal-unpaid-invoices-recovery-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

const searchSchema = type({ 'status?': "'success' | 'partialSuccess'" })

export const Route = createFileRoute('/(customer)/_portal/unpaid-invoices/')({
  validateSearch: searchSchema,
  component: function Component() {
    const { status } = Route.useSearch()
    return (
      <PermissionChecker requiredPermissions={['invoice.read']}>
        <PortalUnpaidInvoicesRecoveryPage status={status} />
      </PermissionChecker>
    )
  },
})
